import styled, { keyframes } from 'styled-components';

import { mediaQuery } from '../../../styles/global';

const HeroTextKeyframe = keyframes`
  0% {
    opacity: 0;
    top: 20px;
   }
  100% {
    opacity: 1;
    top: 0;
  }
`;

export const Caption = styled.h1`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 4rem;
  margin: 0;
  text-align: center;
  line-height: 100%;

  ${mediaQuery.maxWidth.phone} {
    font-size: 2rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 75vh;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  padding: 13.25rem 20px 0;
  font-family: ${({ theme }) => theme.fontFamily.regular};

  ol {
    ${mediaQuery.maxWidth.tablet} {
      padding-left: 20px;
    }
  }
  i {
    color: white;
    font-style: normal;
    font-family: ${({ theme }) => theme.fontFamily.medium};
  }

  ${mediaQuery.maxWidth.phone} {
    min-height: 90vh;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (orientation: landscape) and (max-height: 700px) {
    position: relative;
    bottom: unset;
    left: unset;
    transform: none;
    padding-bottom: 30px;
  }
  text-align: center;
`;

export const TextBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;
  z-index: 5;
`;

export const Articles = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  z-index: 5;
  justify-content: center;
  margin-top: 68px;
  margin-bottom: 5rem;
`;

export const Description = styled.h2`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  max-width: 53rem;
  opacity: 0;
  position: relative;
  animation: ${HeroTextKeyframe};
  animation-delay: 0.5s;
  animation-duration: 1000ms;
  animation-fill-mode: forwards;
  font-weight: 400;
  margin-top: 24px;

  ${mediaQuery.maxWidth.phone} {
    font-size: 20px;
    margin-top: 20px;
  }
`;

export const Spotlight = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-top: 72px;
`;
